import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {
  static values = {
    visible: { type: Number, default: 0 },
    hidden: { type: Number, default: 0 },
    removed: { type: Number, default: 0 },
  };

  connect() {
    requestAnimationFrame(() => this.render());
  }

  disconnect() {
    this._chart?.destroy();
  }

  render() {
    const visible = this.visibleValue;
    const hidden = this.hiddenValue;
    const removed = this.removedValue;

    if (visible + hidden + removed === 0) return;

    this._chart = new ApexCharts(this.element, {
      chart: {
        type: "donut",
        height: 40,
        width: 40,
        sparkline: { enabled: true },
        animations: { enabled: false },
        background: "transparent",
      },
      series: [visible, hidden, removed],
      labels: ["Top", "Newest", "Removed"],
      colors: ["#22c55e", "#f59e0b", "#ef4444"],
      plotOptions: {
        pie: {
          donut: { size: "55%" },
        },
      },
      dataLabels: { enabled: false },
      legend: { show: false },
      tooltip: {
        enabled: true,
        y: { formatter: (val) => val },
      },
      stroke: {
        width: 1,
        colors: [this.resolvedBase100()],
      },
    });

    this._chart.render();
  }

  // Resolve the computed bg-base-100 color by briefly inserting a throwaway
  // element. Browsers always return rgb(...) regardless of whether the theme
  // uses oklch, hsl, or anything else — so ApexCharts can consume it safely.
  resolvedBase100() {
    const el = document.createElement("div");
    el.className = "bg-base-100";
    el.style.cssText = "position:absolute;visibility:hidden;pointer-events:none";
    document.body.appendChild(el);
    const color = getComputedStyle(el).backgroundColor;
    document.body.removeChild(el);
    return color;
  }
}
